/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown`)
};

const es_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta atrás`)
};

const de_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown`)
};

const nl_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aftelling`)
};

const fr_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte à rebours`)
};

const it_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conto alla rovescia`)
};

const pt_br2_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem Regressiva`)
};

const pt_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem Regressiva`)
};

const ja_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カウントダウン`)
};

const zh_dd_mode_countdown = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒计时`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_mode_countdown = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_mode_countdown(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_mode_countdown", locale)
	if (locale === "en") return en_dd_mode_countdown(inputs)
	if (locale === "es") return es_dd_mode_countdown(inputs)
	if (locale === "de") return de_dd_mode_countdown(inputs)
	if (locale === "nl") return nl_dd_mode_countdown(inputs)
	if (locale === "fr") return fr_dd_mode_countdown(inputs)
	if (locale === "it") return it_dd_mode_countdown(inputs)
	if (locale === "pt-BR") return pt_br2_dd_mode_countdown(inputs)
	if (locale === "pt") return pt_dd_mode_countdown(inputs)
	if (locale === "ja") return ja_dd_mode_countdown(inputs)
	return zh_dd_mode_countdown(inputs)
};